import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

export default ({ app, router, Vue }) => {
	Vue.use(Donut)
}
